import URI from "urijs";

const DEFAULT_API_SEGMENT = ["currentuser", "v1"];

class CurrentuserURIBuilder {
  public apiUrl: string | null;
  public apiSegment: string[];
  public segment: string[] | null;
  public search: object = {};

  constructor() {
    this.apiUrl = null;
    this.apiSegment = DEFAULT_API_SEGMENT;
  }

  public setApiUrl(apiUrl: string): CurrentuserURIBuilder {
    this.apiUrl = apiUrl;
    const { path } = URI.parse(apiUrl);

    if (path && path !== "/") {
      this.apiSegment = [path, ...this.apiSegment];
    }
    return this;
  }

  public setSegment(segment: string | string[]): CurrentuserURIBuilder {
    const localSegment = Array.isArray(segment) ? segment : segment.split("/");
    this.segment = localSegment;

    return this;
  }

  public setSearch(search: object): CurrentuserURIBuilder {
    this.search = search;
    return this;
  }

  public build(): ReturnType<typeof URI> {
    const { apiUrl, apiSegment, segment, search } = this;
    return new URI(apiUrl)
      .segment([...apiSegment, ...(segment ? segment : [])].map((s) => String(s)))
      .setSearch(search);
  }

  public toString(): string {
    return String(this.build());
  }
}

export default CurrentuserURIBuilder;
